import React from 'react';
import Select from 'react-select';

const SelectSearch = ({
  options,
  nameInput,
  isDisabled,
  isLoading,
  value,
  setValue,
  placeholder
}) => {

  const updateFormField = (item) => {
    setValue && setValue(nameInput, item?.value || null);
  };  

  return (
    <Select
      className="basic-single w-100 input-field"
      classNamePrefix="select"
      placeholder={placeholder ? placeholder : 'Seleccione'}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isClearable={false}
      isSearchable={true}
      name={nameInput}
      options={options}
      value={value ? options.find((option) => option.value === value) : null}
      onChange={(selectedOption) => {
        updateFormField(selectedOption);
      }}
    />
  );
};

export default SelectSearch;
